var app = angular.module("leonardo");

var ReportsBillingList = function($scope, $controller, $filter, ReportService) {

  $controller('ReportsBaseController', {$scope: $scope});

  $scope.report_type = ReportService.TYPE_BILLING;

  $scope.title = $filter('translate')('Billing Reports');

  $scope.groupReports = function(data) {
    if (data.results) {
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    }
    else {
      $scope.reports = data;
    }
  };

};

app.controller('ReportsBillingList', ['$scope', '$controller', '$filter', 'ReportService', ReportsBillingList]);
